const ReferralCodeActiveIcon = () => {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.4'
        d='M17.525 8.05125C17.455 8.04125 17.385 8.04125 17.315 8.05125C15.765 8.00125 14.535 6.73125 14.535 5.17125C14.535 3.58125 15.825 2.28125 17.425 2.28125C19.015 2.28125 20.315 3.57125 20.315 5.17125C20.305 6.73125 19.075 8.00125 17.525 8.05125Z'
        fill='#292D32'
      />
      <path
        opacity='0.4'
        d='M20.785 14.9816C19.665 15.7316 18.095 16.0116 16.645 15.8216C17.025 15.0016 17.225 14.0917 17.235 13.1317C17.235 12.1317 17.015 11.1817 16.595 10.3517C18.075 10.1517 19.645 10.4316 20.775 11.1816C22.355 12.2216 22.355 13.9316 20.785 14.9816Z'
        fill='#292D32'
      />
      <path
        opacity='0.4'
        d='M6.43502 8.05125C6.50502 8.04125 6.57502 8.04125 6.64502 8.05125C8.19502 8.00125 9.42502 6.73125 9.42502 5.17125C9.42502 3.58125 8.13502 2.28125 6.53502 2.28125C4.94502 2.28125 3.64502 3.57125 3.64502 5.17125C3.65502 6.73125 4.88502 8.00125 6.43502 8.05125Z'
        fill='#292D32'
      />
      <path
        opacity='0.4'
        d='M6.54499 13.1318C6.54499 14.1018 6.75499 15.0218 7.13499 15.8518C5.72499 16.0018 4.25499 15.7018 3.17499 14.9918C1.59499 13.9418 1.59499 12.2318 3.17499 11.1818C4.24499 10.4618 5.75499 10.1718 7.17499 10.3318C6.76499 11.1718 6.54499 12.1218 6.54499 13.1318Z'
        fill='#292D32'
      />
      <path
        d='M12.115 16.1512C12.035 16.1412 11.945 16.1412 11.855 16.1512C10.015 16.0912 8.54504 14.5813 8.54504 12.7213C8.54504 10.8213 10.075 9.28125 11.985 9.28125C13.885 9.28125 15.425 10.8213 15.425 12.7213C15.425 14.5813 13.965 16.0912 12.115 16.1512Z'
        fill='#292D32'
      />
      <path
        d='M8.86504 18.2219C7.35504 19.2319 7.35504 20.8919 8.86504 21.8919C10.585 23.0419 13.405 23.0419 15.125 21.8919C16.635 20.8819 16.635 19.2219 15.125 18.2219C13.415 17.0719 10.595 17.0719 8.86504 18.2219Z'
        fill='#292D32'
      />
    </svg>
  );
};
export { ReferralCodeActiveIcon };
